module.exports = __webpack_public_path__ + "static/media/house.c00c21c0.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/house.png
// module id = 660
// module chunks = 0